import { useCallback, useMemo, useState } from "react";
import { BrandEnum } from "../../../_common/enum/brand.enum";
import { IMortgageQuote } from "../../../_common/interface/mortgageQuote/iMortgageQuote.interface";
import { IFilteringViewModel } from "../../../_common/interface/table";
import { TABLE_FILTER } from "../../../_const/tableFilter.const";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { quoteComparisonService } from "../../../_services/quoteComparison.service";

export function useMortgageQuotes(formId?: string, brand?: BrandEnum) {
    const [data, setData] = useState<IMortgageQuote[]>([]);
    const [isLoading, setLoading] = useState(false);

    const [filter, setFilter] = useState<IFilteringViewModel>({ formId: 0 });
    const [pagination, setPagination] = useState({
        pageIndex: filter?.pageIndex || TABLE_FILTER.pageIndex || 0,
        pageSize: filter?.pageSize || TABLE_FILTER.pageSize || 10,
    });
    const [sorting, setSorting] = useState<any>([]);

    const requestFilter = useMemo(() => {
        return {
            ...filter,
            formId: Number(formId),
            brand,
            search: "",
            pageIndex: pagination.pageIndex,
            pageSize: pagination.pageSize,
            order: sorting.length && sorting[0].desc ? "desc" : "asc",
            orderBy: sorting.length ? sorting[0].id : "",
        } as IFilteringViewModel;
    }, [filter, formId, brand, pagination.pageIndex, pagination.pageSize, sorting]);

    const fetchQuotes = useCallback(async () => {
        if (!formId || !brand) return;
        setLoading(true);
        try {
            const res = await quoteComparisonService.getMortgageQuotes(requestFilter);
            setData(res);
        } catch (e) {
            setData([]);
            handleErrorResponse(e);
        } finally {
            setLoading(false);
        }
    }, [formId, brand, requestFilter]);

    return {
        data,
        isLoading,
        fetchQuotes,
        filter,
        setFilter,
        pagination,
        setPagination,
        sorting,
        setSorting,
    };
}
